// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DatabaseAccessIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19.91 4.76a7 7 0 0 0-1.55-.77c-2.05-.7-4.2-1.04-6.36-1a19 19 0 0 0-6.36 1q-.83.29-1.55.77A2.1 2.1 0 0 0 3 6.36v10.87c0 1.87 4 3.38 9 3.38s9-1.51 9-3.38V6.36a2.1 2.1 0 0 0-1.09-1.6m-.41 8.83c-.34.58-2.86 1.88-7.48 1.88s-7.16-1.27-7.45-1.85v-1.76a16 16 0 0 0 7.43 1.5c2.58.1 5.15-.42 7.5-1.51zm0-3.61c-.34.58-2.86 1.87-7.48 1.87S4.86 10.58 4.57 10V8.27a16 16 0 0 0 7.5 1.51c2.58.1 5.15-.42 7.5-1.51zM5.15 5.85l.33-.16.3-.15.44-.18.4-.15.56-.15.48-.13.7-.14.54-.1.91-.1.54-.05q.74-.06 1.56-.06h.18q.83 0 1.56.06l.54.05.91.1.53.1.71.14.48.13.56.15.4.15.44.16.3.15.33.16.2.14.22.15.11.12.1.12c-.36.58-2.88 1.87-7.48 1.87S4.87 6.96 4.57 6.36l.1-.12.11-.12.21-.15zM12 19.12c-4.71 0-7.25-1.35-7.5-1.91v-1.73A16 16 0 0 0 12 17c2.59.1 5.16-.43 7.5-1.52v1.73c-.25.56-2.79 1.91-7.5 1.91"
    />
    <path
      fill="currentColor"
      d="M17.96 10.45a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M15.86 10.93a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M17.96 14.02a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M15.86 14.51a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M17.96 17.62a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M15.86 18.1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    />
  </svg>,
  "DatabaseAccess",
);
export default DatabaseAccessIcon;
